import React from 'react';
import Holiday_Staff_List from './Holiday_Staff_List';
import '../../../CommonCSS/SocietyCSS.css'

const Holiday_Staff_ListApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Holiday Staff List </h5>
          </div>  
        </div>
        <Holiday_Staff_List/>
      </div>
    </div >
  );
};

export default Holiday_Staff_ListApp;
